// extracted by mini-css-extract-plugin
export default {"grupo-economico-edit-container":"GrupoEconomico_grupo-economico-edit-container__tMaO3","grupo-economico-edit-form":"GrupoEconomico_grupo-economico-edit-form__Rahsh"};